import { render } from "./KakaoLogin.vue?vue&type=template&id=0486a142&scoped=true"
import script from "./KakaoLogin.vue?vue&type=script&lang=js"
export * from "./KakaoLogin.vue?vue&type=script&lang=js"

import "./KakaoLogin.vue?vue&type=style&index=0&id=0486a142&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0486a142"]])

export default __exports__